<template>
  <div class="container shadow-wrapper flex-cc dir-col height-m">
    <h1 class="mb-m">{{ displayText.title }}</h1>
    <img src="@/assets/icon-success.png" class="mb-s" :style="{ width: '100px', height: '100px' }" />
    <p class="fz-small">{{ displayText.tips }}</p>
    <p class="fz-small">{{ displayText.tel }}</p>
    <p class="fz-small">
      本頁將在十秒後跳轉至平台首頁，若未成功跳轉，請點
      <router-link to="/">這裡</router-link>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      timer: null
    };
  },
  computed: {
    displayText() {
      const {
        $route: { path }
      } = this;
      const isSignup = path.includes("signup");
      const title = isSignup ? "註冊完成" : "投保完成";
      const tips = isSignup
        ? "註冊成功"
        : "保單受理成功！您的保費將於核保通過後才進行扣款並寄發保單，您可至會員中心「我的保單」查詢本次投保資訊。";
      const tel = isSignup
        ? ""
        : "按法令規定，網路投保成功需要電訪抽樣確認，如您接到電訪確認請勿擔心，感謝您的配合，謝謝!";
      return { title, tips, tel };
    }
  },
  mounted() {
    const { $router } = this;
    this.timer = setTimeout(() => {
      $router.push("/");
    }, 10000);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>